// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 677 ? "src_pages_SectionPage_jsx" : chunkId) + "." + {"222":"8451e760","649":"fd77af4e","677":"978ff4ef","704":"59eb9262"}[chunkId] + ".chunk.css";
};